import React, { FC } from "react";

import Select from "../../../../../components/elements/Select";
import classes from "../../CampaignsDashboard.module.scss";
import { SelectOptionType } from "../../../../../components/elements/Select/Select";

type TimeFrameSelectorProps = {
  selectedTimeFrame: string;
  handleTimeFrameChange: (event: any) => void;
};

const TimeFrameSelector: FC<TimeFrameSelectorProps> = ({ selectedTimeFrame, handleTimeFrameChange }) => {
  const options: SelectOptionType[] = [
    {
      label: "7 Days",
      value: "7_DAYS",
    },
    {
      label: "30 Days",
      value: "30_DAYS",
    },
    {
      label: "90 Days",
      value: "90_DAYS",
    },
    {
      label: "All time",
      value: "ALL_TIME",
    },
  ];

  return (
    <Select
      className={classes.selector}
      value={selectedTimeFrame}
      options={options}
      onChange={handleTimeFrameChange}
      label="Time Frame"
      displayEmpty
    />
  );
};

export default TimeFrameSelector;
